export const REQUIRED_ONBOARDING = 'required-onboarding';
export const PRODUCT = 'product';
export const PURCHASE_MOTIONS = 'purchase-motions';
export const PHONE_NUMBER = 'phone-number';
export const PUBLIC_META = 'public-meta';
export const PRODUCT_INVENTORY = 'product-inventory';
export const IDENTIFICATION_TOKEN = 'identification-token';
export const SEATS_INVENTORY = 'seats-inventory';
export const LIMIT_USAGE = 'limit-usage';
export const COOKIE_ECHO_USER = 'cookie-echo-user';